import React from 'react'
import { useTranslation } from 'react-i18next'
import Input, { InputProps } from 'components/Input'

export enum VehicleConditions {
  ACCIDENT = 'accident',
  BRAKE_FAILURE = 'brakeFailure',
  BROKEN_GLASS = 'brokenGlass',
  OUT_OF_CHARGE = 'outOfCharge',
  OVERHEATED = 'overheated',
  RUNS_POORLY = 'runsPoorly',
  FLAT_NO_SPARE = 'flatTireNoSpare',
  FLAT_TIRES = 'flatTires',
  STUCK = 'stuck',
  KEYS_LOCKED = 'keysLocked',
  LEAKING_FLUIDS = 'leakingFluids',
  LOST_KEY = 'lostKey',
  MAINTENANCE_LIGHT = 'maintenanceLight',
  NO_START = 'noStart',
  SUSPENSION_FAILURE = 'suspensionFailure',
  TRANSMISSION_FAILURE = 'transmissionFailure',
  FIRE = 'fire',
  MIS_FUELED = 'misFueled',
  OTHER = 'other',
}

const DISABLED_FOR_TOW = new Set<VehicleConditions>([
  VehicleConditions.KEYS_LOCKED,
  VehicleConditions.LOST_KEY,
  VehicleConditions.FLAT_NO_SPARE,
  VehicleConditions.FLAT_TIRES,
])

export function VehicleConditionSelect(props: InputProps & { callType?: string }) {
  const { t } = useTranslation()

  const { callType, ...rest } = props
  const isTow = callType === 'Tow'

  const options = React.useMemo(() => {
    return Object.values(VehicleConditions)
      .filter((condition) => condition !== VehicleConditions.OTHER)
      .map((condition) => ({
        label: t(`vehicleCondition.${condition}`),
        value: condition,
      }))
  }, [t])

  const isDisabledOption = (value: VehicleConditions) => isTow && DISABLED_FOR_TOW.has(value)

  return (
    <Input.Select
      placeholder="--"
      options={options}
      isClearable
      {...rest}
      isOptionDisabled={(option) => isDisabledOption(option.value)}
      formatOptionLabel={(option) => {
        const isDisabled = isDisabledOption(option.value)
        return <span title={isDisabled ? t('vehicleCondition.disabledReason') : undefined}>{option.label}</span>
      }}
      style={{ pointerEvents: 'auto' }}
    />
  )
}

export default VehicleConditionSelect
